import { INIT, SUCCESS, LOADING, ERROR } from "../../../utils/constants";
import {
  GET_PREVIOUS_ALERTS,
  GET_PREVIOUS_ALERTS_SUCCESS,
  GET_PREVIOUS_ALERTS_ERROR,
} from "./constant";
import { getPreviousAlertsInfo } from "./action";

const initialState = {
  phase: INIT,
  previousAlertsList: null,
  error: null,
};

export function PreviousAlertsStore(state = initialState, action) {
  switch (action.type) {
    case GET_PREVIOUS_ALERTS:
      return {
        ...state,
        phase: LOADING,
      };
    case GET_PREVIOUS_ALERTS_SUCCESS:
      return {
        ...state,
        phase: SUCCESS,
        previousAlertsList: action.data,
        error: null,
      };
    case GET_PREVIOUS_ALERTS_ERROR:
      return {
        ...state,
        phase: ERROR,
        error: action.error,
      };
    default:
      return state;
  }
}

export { getPreviousAlertsInfo };
